import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UtilsModule } from 'src/app/utils/utils.module';

import { LandingComponent } from './landing.component';
import { HeaderModule } from './../header/header.module';
import { WidgetGisModuleModule } from './../../widget-gis-components/widget-gis-module.module';
import { AuthModule } from '../../authentication/auth.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { DeleteUserComponent } from '../../authentication/delete-user/delete-user.component';

export const routes: Routes = [
  { path: 'landing-page', component: LandingComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    HeaderModule,
    UtilsModule,
    WidgetGisModuleModule,
    AuthModule,
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // })
  ],
  entryComponents: [DeleteUserComponent],
  declarations: [LandingComponent],
  bootstrap: [LandingComponent]
})
export class LandingModule { }
